"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPersonalSubscription = addPersonalSubscription;
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
async function addPersonalSubscription({
  client,
  globalShoppingPersonalSubscriptionDto,
  sessionId,
  tenant,
  placement,
  referer
}) {
  // TODO -- Is this needed when there is the tenant prop of ApiProvider applied on some upper level?
  const headers = {
    [_fetching.PLACEMENT]: placement,
    [_fetching.TENANT_CONTEXT]: tenant,
    // eslint-disable-next-line @typescript-eslint/naming-convention -- correct naming
    'x-referer': String(referer)
  };
  return (0, _globalApiClientReact.createShoppingSessionPersonalSubscription)(client, sessionId, globalShoppingPersonalSubscriptionDto, headers);
}
